// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2AxdN","selected":"Chip_selected__3w5ze"};